/**
 * utils/riskDisplayHelpers.ts
 * Shared risk value formatting for RiskSpec display.
 *
 * Handles both percentage (e.g. "1.00%") and fixed-currency (e.g. "$100.00")
 * risk specifications. Used across Settings risk editors, Pre-Trading risk
 * selection, and Live Trading risk context display.
 */

import type { RiskSpec } from '@/types/schema/AccountRisk';
import { formatPercentage } from '@/utils/numberHelpers';
import { formatMoney } from '@/utils/moneyHelpers';

/** Format a RiskSpec for display (e.g. "1.00%" or "$100.00") */
export function formatRisk(risk: RiskSpec, currency: string): string {
  if (risk.type === 'percentage') {
    return formatPercentage(risk.value, 2);
  }
  return formatMoney(risk.value, currency, 2);
}
